import React, { useState, useEffect  }  from 'react'
import Table from 'react-bootstrap/Table';
import { FaPlusCircle, FaEdit, FaTrash, FaFilter } from 'react-icons/fa';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import ReactQuill from 'react-quill'; // Import ReactQuill
import DOMPurify from 'dompurify'; // Import DOMPurify
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import * as jobIntTypeApi from './../../api/jobIntTypeApi'
import * as jobApi from './../../api/jobApi'
import { useSignalAbort } from '../../api/useSignalAbort';
// import { ToastContainer } from 'react-toastify';
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from 'react-bootstrap';
import { handleApiErrors } from "../../api/handleApiErrors";
 
const defaultJobDetails = {
  JobCode: '',
  Title: '',
  IndustryName: '',
  CompanyName: '',
  JobTypeName: '',
  ExpYears: '',
  Location: '',
  Responsibility: '',
  CompanyLogo: '',
  IsActive: 1, 
 };
function JobListing() {
  
const abortConstants = useSignalAbort()
const [isLoading, setIsLoading] = useState(false);

const [showAddModal, setShowAddModal] = useState(false);
const [showEditModal, setShowEditModal] = useState(false);
const [editIndex, setEditIndex] = useState(null);
const [jobDetails, setJobDetails] = useState(defaultJobDetails);
const [selectedLogo, setSelectedLogo] = useState(null);
const [industry,setIndustry] = useState()
const [industrySelect,setIndustrySelect] = useState()
const [jobType,setJobType] = useState()
const [jobTypeSelect,setJobTypeSelect] = useState()

const [showDeleteModal, setShowDeleteModal] = useState(false);
const [jobToDelete, setJobToDelete] = useState(null);

const [validated, setValidated] = useState(false);
const [errors, setErrors] = useState({});

 
 
//joblist
const [jobList, setJobList] = useState([])

// Function to render only the first two lines of the content
const renderShortResponsibility = (htmlString) => {
  const lines = htmlString.slice(0, 100); // Get the first two lines
  return lines ; // Add ellipsis if content is truncated
};

// Modal for displaying full responsibility content
const [showFullResponsibilityModal, setShowFullResponsibilityModal] = useState(false);
const [fullResponsibilityContent, setFullResponsibilityContent] = useState('');

const handleShowFullResponsibility = (content) => {
  setFullResponsibilityContent(content);
  setShowFullResponsibilityModal(true);
};



const [show, setShow] = useState(false);

const handleClose = () => setShow(false);
const handleShow = () => setShow(true);

useEffect(() => {
  getAllData(abortConstants.controllerConfig)
},[])

 const getAllData = (abortToken) => {
  getIndustry(abortToken)
  getJobType(abortToken)
  getAllJob(abortToken)
}

//Joblist
const getAllJob = async (abortToken) => {
  try {
     const result = await jobApi.getJob(abortToken)
    
    setJobList(result.data.Job)
    console.log(result.data.Job);
  }
  catch (error) {
     console.log(error);
     handleApiErrors(error, 'JobListing', 'jobListing_response', 'jobListing_timeout', 'jobListing_request', setIsLoading);

  }
}


 //for add job api call
 const createJob = async (data,abortToken) => {
  console.log(data);
  try {
     const result = await jobApi.createJob(data,abortToken)

     if(result){
      setIsLoading(false);
    }

    //  toast.success(result.data.message)
    toast.success("Job created successfully!", {
      autoClose: 5000, // Close the toast after 5 seconds
    });
    
    console.log(result);
  }
  catch (error) {
    console.log(error);
    toast.error(error)
    handleApiErrors(error, 'JobListing', 'jobListing_response', 'jobListing_timeout', 'jobListing_request', setIsLoading);
    setIsLoading(false);
   }
}

  //for   UPDATE api call
  const updateJob = async (id,data,abortToken) => {
    console.log("edit",id,data);
    try {
       const result = await  jobApi.updateJob(id,data,abortToken)

       if(result){
        setIsLoading(false);
      }

//  toast.success(result.data.message)
toast.success("Job updated successfully!", {
  autoClose: 5000, // Close the toast after 5 seconds
});
       console.log(result);

    }
    catch (error) {
      console.log(error);
      toast.error(error)
      handleApiErrors(error, 'JobListing', 'jobListing_response', 'jobListing_timeout', 'jobListing_request', setIsLoading);
      setIsLoading(false);
    }
  }

 

const deleteJob = async (id) => {
  setJobToDelete(id);
  setShowDeleteModal(true);
};

const handleDeleteJob = async () => {
  try {
    await jobApi.deleteJob(jobToDelete);
    const updatedJobList = jobList.filter((job) => job.JobId !== jobToDelete,abortConstants.controllerConfig);
    
    //  toast.success(result.data.message)
    toast.success("Job deleted successfully!", {
      autoClose: 5000, // Close the toast after 5 seconds
    });

    setJobList(updatedJobList);
    setShowDeleteModal(false);
  } catch (error) {
    console.log(error);
    toast.error(error)
    handleApiErrors(error, 'JobListing', 'jobListing_response', 'jobListing_timeout', 'jobListing_request', setIsLoading);

  }
};

const handleCancelDelete = () => {
  setShowDeleteModal(false);
  setJobToDelete(null);
};

const renderLoading = (item) => {
  if (isLoading[`${item}_response`] || isLoading[`${item}_request`] || isLoading[`${item}_timeout`]) {
    return true;
  } else {
    return false;
  }
}

//industry
const getIndustry = async (abortToken)=>{
  try{
    const result= await jobIntTypeApi.getIndustry(abortToken)
    setIndustry(result?.data?.Industry);
    setIndustrySelect(result?.data?.Industry[0]?.IndustryId)
console.log(result?.data?.Industry);
   
  }
  catch(error){
   console.log(error);
  }
}

const handleIndustryselect = (e) => {
  setIndustrySelect(e.target.value);
  console.log(industrySelect);
}
 

//jobtype
const getJobType = async (abortToken)=>{
  try{
    const result= await jobIntTypeApi.getJobType(abortToken)
    setJobType(result?.data?.JobType);
    setJobTypeSelect(result?.data?.JobType[0]?.JobTypeId)
console.log(result?.data?.JobType);
   
  }
  catch(error){
   console.log(error);
  }
}

const handleJobTypeselect = (e) => {
  setJobTypeSelect(e.target.value);
  console.log(e.target.value);
}

  
  

  // Handle input change in job details
  const handleChange = (e) => {
    if (e.target.name === 'IsActive') {
      setJobDetails({ ...jobDetails, IsActive: e.target.checked ? 1 : 0 });
    } else {
      setJobDetails({ ...jobDetails, [e.target.name]: e.target.value });
    }
  };

 // Handle image change
const handleLogoChange = (e) => {
  const file = e.target.files[0];
  const reader = new FileReader();

  reader.onload = () => {
    try {
      const base64Data = reader.result.split(',')[1]; // Get base64 data excluding the data URI scheme
     
      setJobDetails({
        ...jobDetails,
        CompanyLogo: base64Data
      });
      setSelectedLogo(reader.result);
     } catch (error) {
      console.error('Error handling image data:', error);
      // Handle the error (e.g., show an error message to the user)
    }
  };

  reader.readAsDataURL(file);
};

  

  // Toggle add modal
  const toggleAddModal = () => {
    setShowAddModal(!showAddModal);
    if (!showAddModal) {
      resetJobDetails();
    }
  };

  // Toggle edit modal
  const toggleEditModal = (index) => {
    console.log(index);
    const job_id = jobList[index]?.JobId
    setIndustrySelect(jobList[index]?.IndustryId)
    setJobTypeSelect(jobList[index]?.JobTypeId)
    setEditIndex(job_id);
    if (!showEditModal) {
      setJobDetails(jobList[index]); 
      setSelectedLogo(`${process.env.REACT_APP_BASE_URL}${jobList[index]?.CompanyLogo}`)
    }
        setShowEditModal(!showEditModal);
        console.log(jobList[index]);
  };

console.log(jobDetails);

  // Reset job details
  const resetJobDetails = () => {
    setJobDetails(defaultJobDetails); // Reset to default values
    setSelectedLogo(null);
  };

// Handle add form submit
const handleSubmit = (e) => {
  setIsLoading(true);
  e.preventDefault();

  const form = e.currentTarget;
  
  if (form.checkValidity() === false) {
    e.stopPropagation();
    setValidated(true);
    setIsLoading(false);

    return;
  }

  let newData = {
    ...jobDetails,
    IndustryId:Number(industrySelect),
    JobTypeId:Number(jobTypeSelect),
    }
    
  console.log(newData);
  console.log(selectedLogo);


  const handleCreateJob = async () => {
    try {
      await createJob(newData,abortConstants.controllerConfig);
     
      toggleAddModal(); // Close the modal
      setJobList([...jobList,newData]);
    } catch (error) {
      console.log(error);
     } 
  };

  handleCreateJob(); // Call the asynchronous function
};


// Handle Edit form submit
const handleEditSubmit = async  (e) => {
  setIsLoading(true);
  e.preventDefault();

  const form = e.currentTarget;
  
  if (form.checkValidity() === false) {
    e.stopPropagation();
    setValidated(true);
    setIsLoading(false);

    return;
  }

  let newData = {
    ...jobDetails,
    IndustryId:Number(industrySelect),
    JobTypeId:Number(jobTypeSelect),
    // IsActive: e.target.checked ? 1 : 0
  }
  console.log(jobDetails);

  try {
    // Send request to update job data in the backend
    await updateJob(editIndex, newData,abortConstants.controllerConfig);

    // Update local state (jobList) with the edited data
    const updatedJobList = jobList.map((job, index) =>
      index === editIndex ? newData : job
    );
    setJobList(updatedJobList);

    // Close the edit modal
    toggleEditModal();
  } catch (error) {
    console.log(error);
  }
};


 

  
return (
    <div style={{margin :'20px' ,width:'100%'}}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '0' }}>Job Listings</h2>
        <FaPlusCircle size={24} style={{ marginBottom: '10px' ,color:'#172446', cursor: 'pointer'}} onClick={toggleAddModal}/>
       </div>


{/* Add Job Modal */}
<Modal show={showAddModal} onHide={toggleAddModal} backdrop="static">
<Modal.Header closeButton style={{ backgroundColor: '#f8f9fa' }}>
          <Modal.Title style={{color:'#172446',fontFamily:'segoe ui'}}> Add Job </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: '#f8f9fa' }}>
        <Form noValidate validated={validated} onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
          
          {/* row 1 - job code,title*/}
 <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
    <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="JobCode">
        <Form.Label style={{ marginBottom: '5px' }}>Job Code</Form.Label>
        <Form.Control name="JobCode" placeholder="Job Code" value={jobDetails.JobCode} onChange={handleChange} required isInvalid={errors.JobCode} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a valid job code.</Form.Control.Feedback>
      </Form.Group>
    </div>

    <div style={{ flex: '1' }}>
      <Form.Group controlId="Title">
        <Form.Label style={{ marginBottom: '5px' }}>Title</Form.Label>
        <Form.Control name="Title"  placeholder="Title" value={jobDetails.Title} onChange={handleChange} required isInvalid={errors.Title} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a title.</Form.Control.Feedback>
      </Form.Group>
    </div>
 </div>

{/* row 2 - industry , companyname */}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
    <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="industrySelect">
  <Form.Label>Industry</Form.Label>
  <Form.Control  as="select" name="IndustryName"  value={industrySelect} onChange={handleIndustryselect} 
    isInvalid={!industrySelect} isValid={industrySelect} >
    <option value="">Select Industry</option>
    {industry?.map((item) => (
      <option key={item.IndustryName} name={item.IndustryName} value={item.IndustryId}> {item.IndustryName} </option>
    ))}
  </Form.Control>
  <Form.Control.Feedback type="invalid">Please select an industry.</Form.Control.Feedback>
</Form.Group>
    </div>

    <div style={{ flex: '1' }}>
      <Form.Group controlId="CompanyName">
        <Form.Label style={{ marginBottom: '5px' }}>Company Name</Form.Label>
        <Form.Control name="CompanyName"  placeholder="CompanyName" value={jobDetails.CompanyName} onChange={handleChange} required isInvalid={errors.CompanyName} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a Company Name.</Form.Control.Feedback>
      </Form.Group>
    </div>
 </div>

{/* row 3 - job Type, exp years*/}

<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
    <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="jobType">
  <Form.Label>Job Type</Form.Label>
  <Form.Control  as="select" name="JobTypeName"  value={jobTypeSelect} onChange={handleJobTypeselect} 
    isInvalid={!jobTypeSelect} isValid={jobTypeSelect} >
    <option value="">Select jobType</option>
    {jobType?.map((item) => (
      <option key={item.JobTypeName} name={item.JobTypeName} value={item.JobTypeId}> {item.JobTypeName} </option>
    ))}
  </Form.Control>
  <Form.Control.Feedback type="invalid">Please select an jobType.</Form.Control.Feedback>
</Form.Group>
    </div>

    <div style={{ flex: '1' }}>
      <Form.Group controlId="ExpYears">
        <Form.Label style={{ marginBottom: '5px' }}>Exp Years</Form.Label>
        <Form.Control name="ExpYears"  placeholder="ExpYears" value={jobDetails.ExpYears} onChange={handleChange} required isInvalid={errors.ExpYears} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a Exp Years.</Form.Control.Feedback>
      </Form.Group>
    </div>
 </div>

{/* row 4 - location */}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
  <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="Location">
        <Form.Label style={{ marginBottom: '5px' }}>Location</Form.Label>
        <Form.Control name="Location" placeholder="Location" value={jobDetails.Location} onChange={handleChange} required isInvalid={errors.Location} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a valid Location.</Form.Control.Feedback>
      </Form.Group>
  </div>
</div>


{/* row 5 -description */}
<div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
  <label htmlFor="Responsibility" style={{ marginBottom: '5px' }}>Job Description</label>
  <div style={{ marginRight: '10px', flex: '1', maxHeight: '200px', overflowY: 'auto' }}>
          <ReactQuill
     className={`Responsibility-editor ${jobDetails.ResponsibilityFocus ? 'focused' : ''}`}
    value={jobDetails.Responsibility || ''}
    onChange={(value) => setJobDetails({ ...jobDetails, Responsibility: value })}
    onFocus={() => setJobDetails({ ...jobDetails, ResponsibilityFocus: true })}
    onBlur={() => setJobDetails({ ...jobDetails, ResponsibilityFocus: false })}
     modules={{
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image', 'video'],
            ['clean'],
          ] ,
          clipboard: {
            // Add a custom matchers array to define allowed HTML tags and attributes during pasting
            matchers: [
                ['a', 'href', 'title', 'target'],
                ['img', 'src'],
                ['video', 'src'],
            ],
        },
    }}
/>

          </div>
        </div>


{/* row 6 - Image */}

        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
          <div style={{ marginRight: '10px', flex: '1' }}>
          <label htmlFor="logo" style={{ marginBottom: '5px' }}>Company Logo</label>
          <input type="file" accept="image/*" id="logo" name="logo" onChange={handleLogoChange} style={{ display: 'none' }} />
          <label htmlFor="logo" style={{ display: 'block', width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', cursor: 'pointer' }}>
           {selectedLogo ? <img src={selectedLogo} alt="Selected" style={{ maxWidth: '100%', maxHeight: '150px' }} /> : 'Choose File'}
          </label>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-3">
        <button type="submit" className="btn" style={{marginRight:'20px',backgroundColor:'#172446', color:'#fff'}}> 
        
        {isLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
              
              Saving...
            </>
          ) : (
         'Save'
    )}

        </button>
     
        <button type="button" className="btn btn-secondary" onClick={toggleAddModal} style={{marginRight:'20px',  color:'#000'}}>Cancel</button>
      </div>
      </Form>
        </Modal.Body>

      </Modal>





{/* Edit Job Modal */}
<Modal show={showEditModal} onHide={toggleEditModal}  backdrop="static">
<Modal.Header closeButton style={{ backgroundColor: '#f8f9fa' }}>
          <Modal.Title style={{color:'#172446',fontFamily:'segoe ui'}}> Edit Job </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: '#f8f9fa' }}> 
             
          <Form noValidate validated={validated} onSubmit={handleEditSubmit} style={{ display: 'flex', flexDirection: 'column' }}>

 {/* row 1 - job code,title,industrySelect*/}
 <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
    <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="JobCode">
        <Form.Label style={{ marginBottom: '5px' }}>Job Code</Form.Label>
        <Form.Control name="JobCode" placeholder="Job Code" value={jobDetails.JobCode} onChange={handleChange} required isInvalid={errors.JobCode} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a valid job code.</Form.Control.Feedback>
      </Form.Group>
    </div>

    <div style={{marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="Title">
        <Form.Label style={{ marginBottom: '5px' }}>Title</Form.Label>
        <Form.Control name="Title"  placeholder="Title" value={jobDetails.Title} onChange={handleChange} required isInvalid={errors.Title} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a title.</Form.Control.Feedback>
      </Form.Group>
    </div>


    <div style={{ flex: '1' }}>
    <Form.Group controlId="industrySelect">
  <Form.Label>Industry</Form.Label>
  <Form.Control  as="select" name="IndustryName"  value={industrySelect} onChange={handleIndustryselect} 
    isInvalid={!industrySelect} isValid={industrySelect} >
    <option value="">Select Industry</option>
    {industry?.map((item) => (
      <option key={item.IndustryName} name={item.IndustryName} value={item.IndustryId}> {item.IndustryName} </option>
    ))}
  </Form.Control>
  <Form.Control.Feedback type="invalid">Please select an industry.</Form.Control.Feedback>
</Form.Group>
    </div>

 </div>

{/* row 2 - companyname ,ExpYears,jobType*/}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
    <div style={{ marginRight: '10px', flex: '1' }}>
    <Form.Group controlId="CompanyName">
        <Form.Label style={{ marginBottom: '5px' }}>Company Name</Form.Label>
        <Form.Control name="CompanyName"  placeholder="CompanyName" value={jobDetails.CompanyName} onChange={handleChange} required isInvalid={errors.CompanyName} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a Company Name.</Form.Control.Feedback>
      </Form.Group>
    </div>

    <div style={{marginRight: '10px', flex: '1' }}>

<Form.Group controlId="ExpYears">
        <Form.Label style={{ marginBottom: '5px' }}>Exp Years</Form.Label>
        <Form.Control name="ExpYears"  placeholder="ExpYears" value={jobDetails.ExpYears} onChange={handleChange} required isInvalid={errors.ExpYears} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a Exp Years.</Form.Control.Feedback>
      </Form.Group>
    </div>

    <div style={{ flex: '1' }}>
    <Form.Group controlId="jobType">
  <Form.Label>Job Type</Form.Label>
  <Form.Control  as="select" name="JobTypeName"  value={jobTypeSelect} onChange={handleJobTypeselect} 
    isInvalid={!jobTypeSelect} isValid={jobTypeSelect} >
    <option value="">Select jobType</option>
    {jobType?.map((item) => (
      <option key={item.JobTypeName} name={item.JobTypeName} value={item.JobTypeId}> {item.JobTypeName} </option>
    ))}
  </Form.Control>
  <Form.Control.Feedback type="invalid">Please select an jobType.</Form.Control.Feedback>
</Form.Group>
   
      </div>

 </div>

 

{/* row 3 - location, isactive */}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
  <div style={{ marginRight: '10px', flex: '1' }}>
      <Form.Group controlId="Location">
        <Form.Label style={{ marginBottom: '5px' }}>Location</Form.Label>
        <Form.Control name="Location" placeholder="Location" value={jobDetails.Location} onChange={handleChange} required isInvalid={errors.Location} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
        <Form.Control.Feedback type="invalid">Please provide a valid Location.</Form.Control.Feedback>
      </Form.Group>
  </div>

  <div style={{ marginLeft:'70px',flex: '1' }}>
          <label style={{ marginBottom: '10px' }}>Status</label>
          <div style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Check
  type="switch"
  id="custom-switch"
  label="Active"
  checked={jobDetails.IsActive === 1}
  onChange={() => setJobDetails({ ...jobDetails, IsActive: jobDetails.IsActive === 1 ? 0 : 1 })}
/>

</div>

          </div>
</div>

{/* row 4 -description */}
<div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
  <label htmlFor="Responsibility" style={{ marginBottom: '5px' }}>Job Description</label>
  <div style={{ marginRight: '10px', flex: '1', maxHeight: '200px', overflowY: 'auto' }}>
          <ReactQuill
    className={`Responsibility-editor ${jobDetails.ResponsibilityFocus ? 'focused' : ''}`}
    value={jobDetails.Responsibility || ''}
    onChange={(value) => setJobDetails({ ...jobDetails, Responsibility: value })}
    onFocus={() => setJobDetails({ ...jobDetails, ResponsibilityFocus: true })}
    onBlur={() => setJobDetails({ ...jobDetails, ResponsibilityFocus: false })}
    modules={{
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image', 'video'],
            ['clean']
        ]
    }}
/>

          </div>
        </div>


{/* row 5 - Image */}

        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
          <div style={{ marginRight: '10px', flex: '1' }}>
          <label htmlFor="logo" style={{ marginBottom: '5px' }}>Company Logo</label>
          <input type="file" accept="image/*" id="logo" name="logo" onChange={handleLogoChange} style={{ display: 'none' }} />
          <label htmlFor="logo" style={{ display: 'block', width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', cursor: 'pointer' }}>
           {selectedLogo ? <img src={selectedLogo} alt="Selected" style={{ maxWidth: '100%', maxHeight: '150px' }} /> : 'Choose File'}
          </label>
          </div>
        </div>         
        <div className="d-flex justify-content-end mt-3">

        <button type="submit" className="btn" style={{marginRight:'20px',backgroundColor:'#172446', color:'#fff'}}> 
        {isLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
              
              Updating...
            </>
          ) : (
         'Update changes'
    )}
        </button>
        
        <button type="button" className="btn btn-secondary" onClick={toggleEditModal} style={{marginRight:'20px',  color:'#000'}}>Cancel</button>
      </div>
        </Form>        
        </Modal.Body>

      </Modal>


      {renderLoading("jobListing") || jobDetails==null?(
        <div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px' }}>
        {jobDetails === null ? "No data" : <Spinner animation="border" role="status" style={{ color: '#2855A1' }} />}
      </div>
      ):(
<div style={{height:'600px',overflow:'auto' ,marginTop: '20px'}}>
<Table striped bordered hover  >

      <thead>
        <tr>
          
          <th style={{ position: 'sticky', top: -1}}>Job Code</th>
          <th style={{ position: 'sticky', top: -1}}>Title</th>
          <th style={{ position: 'sticky', top: -1}}>Industry</th>
          <th style={{ position: 'sticky', top: -1}}>Company</th>
          <th style={{ position: 'sticky', top: -1}}>Job Type</th>
            <th style={{ position: 'sticky', top: -1}}>Exp Years</th> 
              <th style={{ position: 'sticky', top: -1}}>Location</th> 
              <th style={{ position: 'sticky', top: -1}}>Job Description</th> 
              <th style={{ position: 'sticky', top: -1}}>Company Logo</th> 
              <th style={{ position: 'sticky', top: -1}}>Status</th> 
          <th style={{ position: 'sticky', top: -1}}>Actions</th>

        </tr>
      </thead>

      <tbody>
          {jobList?.map((Job, index) => (
            <tr key={index}>
           
              <td>{Job.JobCode}</td>
              <td>{Job.Title}</td>
              <td>{Job.IndustryName}</td>
              <td>{Job.CompanyName}</td>
              <td>{Job.JobTypeName}</td>
              <td>{Job.ExpYears}</td>
              <td>{Job.Location}</td>
              {/* <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(Job.Responsibility) }} /> */}
              <td>
                {/* Display only the first two lines with a "Read More" button */}
                <div  dangerouslySetInnerHTML={{ __html: renderShortResponsibility(Job.Responsibility) }} />
                <a href="#" onClick={() => handleShowFullResponsibility(Job.Responsibility)}  >Read More</a>
              </td>
              <td>   

  {Job.CompanyLogo && (
    <img src={`${process.env.REACT_APP_BASE_URL}${Job.CompanyLogo}`} alt="Company Logo" style={{ maxWidth: '50px', maxHeight: '50px' }} />
  )}

</td>


<td>{Job.IsActive === 1 ? 'Active' : 'InActive'}</td>
              <td>
              <FaEdit
    style={{ marginRight: '5px', color: '#172446', cursor: 'pointer' }}
    onClick={() => toggleEditModal(index)} // Update to toggleEditModal
/>
     
                <FaTrash  
                  style={{ marginLeft: '15px', color: 'red', cursor: 'pointer' }}
                  // onClick={() => handleDeleteJob(index)}
                  onClick={() => { deleteJob(Job.JobId) }}
                />

 <Modal show={showDeleteModal} onHide={handleCancelDelete} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this job?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelDelete}>Cancel</Button>
          <Button variant="danger" onClick={handleDeleteJob}>Delete</Button>
        </Modal.Footer>
      </Modal>  

 


              </td>
            </tr>
          ))}
        </tbody>

    </Table>
    </div>
      )}

{/* Modal for displaying full responsibility content */}
<Modal show={showFullResponsibilityModal} onHide={() => setShowFullResponsibilityModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Job Description</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fullResponsibilityContent) }} />
        </Modal.Body>
      </Modal>



    </div>
      )
}




export default JobListing